export const exactTickerRegEx = /^\(\S+\)$/;
